import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getLangObjFromLang } from '@features/phone-subscription/model/utils';
import { changeLanguage } from '@entities/language/store';
import { redirectToStore, setHtmlDirection } from '@shared/utils';
import { LogService } from '@shared/services/LogService';
import { dcbAtom } from '@shared/store/slice-atoms';
import { useQuery } from '@shared/hooks';
import { isLY } from '@entities/country';

const THANKYOU_PAGE_REDIRECT_TIME_DELAY = 7000;

const hasThankyouPayload = (thankyouData: any): boolean =>
  Boolean(thankyouData && Object.keys(thankyouData).length > 0);

export const useApplyLangAndActivationURL = (
  lang: string,
  thankyouData: any,
  noRedirect: boolean,
  setActivationURL: React.Dispatch<React.SetStateAction<null | string>>,
  setHideDownload: React.Dispatch<React.SetStateAction<boolean>> | null = null
): void => {
  const { i18n } = useTranslation();
  const { homeData } = useAtomValue(dcbAtom);
  const { query } = useQuery();
  const queryActivationURL = query.get('activationURL') || '';

  useEffect(() => {
    if (lang) {
      if (lang === 'ar' || lang === 'kr') {
        setHtmlDirection('rtl');
      }

      let langObj = getLangObjFromLang(lang);

      i18n.changeLanguage(langObj.locale);
      changeLanguage(langObj as any);
    }

    if (isLY(homeData.country)) return;

    if (hasThankyouPayload(thankyouData)) {
      if (thankyouData.activationURL) {
        LogService.dcbRedirectToApp(thankyouData.activationURL);
        setActivationURL(thankyouData.activationURL);

        if (!noRedirect) {
          setTimeout(() => {
            window.location = thankyouData.activationURL;
          }, THANKYOU_PAGE_REDIRECT_TIME_DELAY);
        }
      } else if (queryActivationURL) {
        LogService.dcbRedirectToApp(queryActivationURL);
        setActivationURL(queryActivationURL);

        if (!noRedirect) {
          setTimeout(() => {
            window.location = queryActivationURL as string & Location;
          }, THANKYOU_PAGE_REDIRECT_TIME_DELAY);
        }
      } else {
        if (!noRedirect) {
          setTimeout(() => {
            if (setHideDownload !== null) {
              setHideDownload(false);
            }
            redirectToStore();
          }, THANKYOU_PAGE_REDIRECT_TIME_DELAY);
        }
      }
    } else {
      if (setHideDownload !== null) {
        setTimeout(() => {
          setHideDownload(false);
        }, THANKYOU_PAGE_REDIRECT_TIME_DELAY);
      }
    }
  }, [lang, thankyouData, noRedirect, i18n, setActivationURL, setHideDownload, homeData.country, queryActivationURL]);
};
